import { Box, Stack, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { TimelineBadge } from '../../atoms/folder-label/TimelineBadge';
import { TimelineDot } from '../../atoms/folder-label/TimelineDot';

const useStyles = makeStyles(() => ({
    date: {
        fontWeight: 600,
        color: '#374151',
    },
    relative: {
        fontSize: '14px',
        color: '#6b7280',
    },
}));

interface TimelineHeaderProps {
    date: string;
    relativeTime: string;
    count: number;
    type: string;
}

export const TimelineHeader: React.FC<TimelineHeaderProps> = ({
    date,
    relativeTime,
    count,
    type,
}) => {
    const classes = useStyles();

    return (
        <Stack direction="row" alignItems="center" spacing={1.5} mb={1.5}>
            <TimelineDot />
            <Typography className={classes.date}>{date}</Typography>
            <Typography className={classes.relative}>• {relativeTime}</Typography>
            <Box flex={1} />
            <TimelineBadge count={count} type={type} />
        </Stack>
    );
};
